module.exports = __webpack_public_path__ + "static/media/apply-stage-templates.ca8c834f.svg";